import { useEffect, useState } from 'react'

import { crawlerClient } from '@/services/crawler'
import type { CrawlerJobId, ImportSitemapData } from '@/types'
import { CrawlerFailed } from './CrawlerFailed/CrawlerFailed'
import CrawlerSuccess from './CrawlerSuccess/CrawlerSuccess'

type CrawlerStatusProps = {
  jobId: string
}

type CrawlerJob = {
  type: 'done' | 'error'
  url: string
  result: ImportSitemapData
}

export const CrawlerFinished = ({ jobId }: CrawlerStatusProps) => {
  const [job, setJob] = useState<CrawlerJob | null>(null)

  useEffect(() => {
    getJob(jobId)
  }, [])

  const getJob = async (jobId: CrawlerJobId) => {
    const data = await crawlerClient.getFinishedJob(jobId)
    const jobResult = JSON.parse(data.result)

    setJob({
      ...jobResult,
      url: data.parsed_url,
    })
  }

  return (
    job &&
    (job.type === 'done' ? (
      <CrawlerSuccess result={job!.result} jobId={jobId} />
    ) : (
      <CrawlerFailed jobUrl={job!.url} jobId={jobId} />
    ))
  )
}
